import { createFileRoute } from '@tanstack/react-router';
import * as v from 'valibot';
import { PortalProjectsTab } from './-components/portal-projects-tab';

export const Route = createFileRoute('/ngos/portals/$portalId/projects')({
	validateSearch: v.object({
		q: v.fallback(v.optional(v.string()), undefined),
		page: v.fallback(v.optional(v.number()), undefined),
	}),
	component: PortalProjectsTab,
});
